const ActionStatus = {
  INITIAL: 'initial',
  REQUEST: 'request',
  SUCCESS: 'success',
  FAILURE: 'failure',
} as const;

type ActionStatus = typeof ActionStatus[keyof typeof ActionStatus];

export default ActionStatus;
